import styled from 'styled-components';

export const SectionTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-size: 18px;
  color: #212632;
  font-weight: 500;
`;

export const PreviewPage = styled.div`
  width: 793.7px;
  height: 1122.5px;
  background-color: white;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  padding: 10px 18.9px;
  margin: 0 auto;
  overflow: hidden;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  @media print {
    box-shadow: none;
    margin: 0;
    padding: 10px 18.9px;
    height: 1122.5px;
    width: 793.7px;
    @page {
      margin: 0;
      size: A4;
    }
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
`;

export const FullPageModule = styled.div`
  width: 100%;
  height: 100%;
  grid-row: 2/4;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  row-gap: 20px;
`;

export const HalfPageModule = styled.div`
  position: relative;
  overflow: visible;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 20px 30px;
  row-gap: 10px;
`;

// graphs

export const GraphTitle = styled.span`
  color: #747d93;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 18px;
`;

export const GraphTitleOperation = styled.span`
  color: ${(props) => props.color};
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 16px;
`;

export const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  min-height: 300px;

  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid #f3f3f3;
    border-top: 4px solid #1778fb;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
